// Curated preset catalog. Slugs are stable identifiers; `title` is copied to
// the milestone row when logged so future catalog renames don't rewrite
// history. Emoji is fine here — it's universal and adds personality without
// shipping bitmap assets.

export type MilestoneCategory =
  | 'physical'
  | 'social'
  | 'communication'
  | 'feeding'
  | 'sleep'
  | 'other';

export type MilestonePreset = {
  slug: string;
  title: string;
  emoji: string;
  category: MilestoneCategory;
};

export const MILESTONE_PRESETS: MilestonePreset[] = [
  // Physical
  { slug: 'head_up', title: 'Held head up', emoji: '🦒', category: 'physical' },
  { slug: 'rolled_over', title: 'Rolled over', emoji: '🔄', category: 'physical' },
  { slug: 'sat_up', title: 'Sat up unassisted', emoji: '🪑', category: 'physical' },
  { slug: 'first_crawl', title: 'First crawl', emoji: '🐢', category: 'physical' },
  { slug: 'pulled_to_stand', title: 'Pulled to stand', emoji: '🧍', category: 'physical' },
  { slug: 'first_steps', title: 'First steps', emoji: '👣', category: 'physical' },
  { slug: 'first_tooth', title: 'First tooth', emoji: '🦷', category: 'physical' },

  // Social
  { slug: 'first_smile', title: 'First smile', emoji: '🙂', category: 'social' },
  { slug: 'social_smile', title: 'Social smile', emoji: '😊', category: 'social' },
  { slug: 'first_laugh', title: 'First laugh', emoji: '😄', category: 'social' },
  { slug: 'eye_contact', title: 'First eye contact', emoji: '👀', category: 'social' },
  { slug: 'waved', title: 'First wave', emoji: '👋', category: 'social' },

  // Communication
  { slug: 'first_coo', title: 'First coo', emoji: '🐦', category: 'communication' },
  { slug: 'first_word', title: 'First word', emoji: '💬', category: 'communication' },
  { slug: 'first_sentence', title: 'First sentence', emoji: '🗣️', category: 'communication' },

  // Feeding
  { slug: 'first_solids', title: 'Started solids', emoji: '🥄', category: 'feeding' },
  { slug: 'first_finger_food', title: 'First finger food', emoji: '🥕', category: 'feeding' },
  { slug: 'first_cup', title: 'First cup', emoji: '🥛', category: 'feeding' },

  // Sleep
  { slug: 'slept_through_night', title: 'Slept through the night', emoji: '🌙', category: 'sleep' },
  { slug: 'own_crib', title: 'Own crib / room', emoji: '🛏️', category: 'sleep' },
];

export const MILESTONE_BY_SLUG = new Map(MILESTONE_PRESETS.map((p) => [p.slug, p]));

export const CATEGORY_LABELS: Record<MilestoneCategory, string> = {
  physical: 'Physical',
  social: 'Social',
  communication: 'Words',
  feeding: 'Feeding',
  sleep: 'Sleep',
  other: 'Other',
};
